export default __webpack_public_path__ + "static/media/megane-medium2.0166c906.jpg";